/* @pareto-engineering/generator-front 1.0.12 */
import * as React from 'react';
import { useState, useRef, useCallback } from 'react';
import { $getSelection, $isRangeSelection } from 'lexical';
import { $patchStyleText } from '@lexical/selection';
import PropTypes from 'prop-types';
import styleNames from '@pareto-engineering/bem/exports';
import "./styles.scss";
import { Popover } from "../../../../../a";
import { useOutsideClick } from "../../../../../utils";

// Local Definitions

const baseClassName = styleNames.base;
const componentClassName = 'font-size-drop-down';
const FONT_SIZE_OPTIONS = [['10px', '10px'], ['11px', '11px'], ['12px', '12px'], ['13px', '13px'], ['14px', '14px'], ['15px', '15px'], ['16px', '16px'], ['17px', '17px'], ['18px', '18px'], ['19px', '19px'], ['20px', '20px']];

/**
 * This is the component description.
 */
const FontSizeDropDown = ({
  id,
  className: userClassName,
  style,
  editor,
  value
  // ...otherProps
}) => {
  const parentRef = useRef(null);
  const [isOpen, setIsOpen] = useState(false);
  useOutsideClick(parentRef, () => setIsOpen(false));
  const handleClick = useCallback(option => {
    editor.update(() => {
      const selection = $getSelection();
      if ($isRangeSelection(selection)) {
        $patchStyleText(selection, {
          'font-size': option
        });
      }
    });
  }, [editor]);
  return /*#__PURE__*/React.createElement("button", {
    id: id,
    className: [baseClassName, componentClassName, userClassName, 'group'].filter(e => e).join(' '),
    style: style,
    ref: parentRef,
    type: "button",
    onClick: () => setIsOpen(!isOpen)
    // {...otherProps}
  }, /*#__PURE__*/React.createElement("span", null, value), /*#__PURE__*/React.createElement("span", {
    className: "icon"
  }, "V"), isOpen && /*#__PURE__*/React.createElement(Popover, {
    parentRef: parentRef,
    isOpen: isOpen,
    color: "background-far"
  }, FONT_SIZE_OPTIONS.map(([option, text]) => /*#__PURE__*/React.createElement("button", {
    className: `item ${value === option ? 'active' : ''}`,
    onClick: () => handleClick(option),
    type: "button"
  }, /*#__PURE__*/React.createElement("span", {
    className: "text"
  }, text)))));
};
FontSizeDropDown.propTypes = {
  /**
   * The HTML id for this element
   */
  id: PropTypes.string,
  /**
   * The HTML class names for this element
   */
  className: PropTypes.string,
  /**
   * The React-written, css properties for this element.
   */
  style: PropTypes.objectOf(PropTypes.string)
};
FontSizeDropDown.defaultProps = {
  // someProp:false
};
export default FontSizeDropDown;